import { Plus, Trash2 } from "lucide-react";
import { TInput, Toggle, Btn } from "./ui";

const OPTS = ["size", "color", "edition", "format"];
const norm = (v) => ({ id: "", label: "", options: {}, sku: "", inventory: null, priceAdjustment: 0, active: true, ...v });

export default function VariantsEditor({ value, onChange }) {
  const variants = Array.isArray(value) ? value.filter((v) => typeof v === "object") : [];
  const setAt = (i, patch) => onChange(variants.map((v, j) => (j === i ? { ...norm(v), ...patch } : v)));
  const setOpt = (i, k, val) => {
    const v = norm(variants[i]);
    setAt(i, { options: { ...v.options, [k]: val || undefined } });
  };
  const add = () => onChange([...variants, { ...norm({}), id: crypto.randomUUID() }]);
  const remove = (i) => onChange(variants.filter((_, j) => j !== i));

  return (
    <div className="md:col-span-3 border-t border-white/10 pt-4" data-testid="variants-editor">
      <div className="flex items-center justify-between mb-3">
        <p className="font-mono text-[9px] tracking-[0.3em] text-gold">
          VARIANTS — SIZE / COLOR / EDITION / FORMAT · EACH WITH ITS OWN SKU, STOCK & PRICE ADJUSTMENT
        </p>
        <Btn variant="ghost" onClick={add} testid="variant-add">
          <span className="inline-flex items-center gap-2"><Plus size={12} /> ADD VARIANT</span>
        </Btn>
      </div>
      {variants.length === 0 && (
        <p className="font-mono text-[9px] text-white/30 border border-dashed border-white/15 p-3">
          NO VARIANTS — THE PRODUCT SELLS AS A SINGLE CONFIGURATION.
        </p>
      )}
      <div className="space-y-2">
        {variants.map((raw, i) => {
          const v = norm(raw);
          return (
            <div key={v.id || i} data-testid={`variant-row-${i}`}
              className="border border-white/10 bg-[#0c0c0c] p-3 grid grid-cols-2 md:grid-cols-12 gap-3 items-end">
              <div className="md:col-span-2">
                <TInput label="LABEL (SHOWN TO BUYERS)" value={v.label} onChange={(x) => setAt(i, { label: x })}
                  placeholder="M / Black" testid={`variant-${i}-label`} />
              </div>
              {OPTS.map((k) => (
                <div key={k} className="md:col-span-1">
                  <TInput label={k.toUpperCase()} value={v.options?.[k]} onChange={(x) => setOpt(i, k, x)}
                    testid={`variant-${i}-${k}`} />
                </div>
              ))}
              <div className="md:col-span-2">
                <TInput label="SKU" value={v.sku} onChange={(x) => setAt(i, { sku: x })} testid={`variant-${i}-sku`} />
              </div>
              <div className="md:col-span-1">
                <TInput label="STOCK" value={v.inventory} onChange={(x) => setAt(i, { inventory: x === "" ? null : Number(x) })}
                  type="number" testid={`variant-${i}-inventory`} />
              </div>
              <div className="md:col-span-1">
                <TInput label="± PRICE (¢)" value={v.priceAdjustment} onChange={(x) => setAt(i, { priceAdjustment: Number(x) || 0 })}
                  type="number" testid={`variant-${i}-price`} />
              </div>
              <div className="md:col-span-2 flex items-center gap-2 pb-1">
                <Toggle label={v.active ? "ACTIVE" : "OFF"} checked={v.active !== false}
                  onChange={(x) => setAt(i, { active: x })} testid={`variant-${i}-active`} />
                <button onClick={() => remove(i)} aria-label="Remove variant" data-testid={`variant-${i}-remove`}
                  className="text-red-400/70 hover:text-red-400 px-1"><Trash2 size={13} /></button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
